import {
    GET_POST_ITEMS,
    GET_POST_ITEMS_SUCCESS,
    GET_POST_ITEMS_ERROR,
    CREATE_POST_NEW_RECORD,
    CREATE_POST_NEW_RECORD_SUCCESS,
    CREATE_POST_NEW_RECORD_ERROR
} from '../actions';

const INIT_STATE = {
    pageNumber: 1,
    postItem:null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_POST_ITEMS:
            return { ...state, loading: true, error: '', postId: action.payload.postId };
        case GET_POST_ITEMS_SUCCESS:
            return { ...state, loading: false, error: '', postItem: action.payload.postItem };
        case GET_POST_ITEMS_ERROR:
            return { ...state, loading: false, error: action.payload.message };     
        case CREATE_POST_NEW_RECORD:
            return { ...state, loading: true, error: "", postItem: action.payload.postItem };
        case CREATE_POST_NEW_RECORD_SUCCESS:
            return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
        case CREATE_POST_NEW_RECORD_ERROR:
            return { ...state, loading: false, error: action.payload.message };               
        default: return { ...state };
    }
}
